import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import EditCampaignPopup from "../popups/EditCampaignPopup";
import ToastPopup from "../popups/ToastPopup";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { FaEdit, FaSort, FaSortDown, FaSortUp, FaBell } from "react-icons/fa";
import FormulaPopup from "../popups/FormulaPopup";
import AccountNamePopup from "../popups/AccountNamePopup";
import BuildFormulaConfirmPopup from "../popups/BuildFormulaConfirmPopup";
import { Campaign, campaignStatusEnums, createToastMessage } from '../interFaces/interfaces';
import { buildUserPayload } from "../main/buildUserPayload";
import EncryptionUtils from "../main/encryptionUtils";
import { ToastMessage } from "../interFaces/interfaces";
const CampaignDetails: React.FC = () => {
  const [data, setData] = useState<Campaign[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [selectedCampaign, setSelectedCampaign] = useState<Campaign | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [isFormulaPopupOpen, setIsFormulaPopupOpen] = useState<boolean>(false);
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState<boolean>(false);
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
  const [selectedFormula, setSelectedFormula] = useState<string>("");
  const [fields, setFields] = useState<any>({});
  const navigate = useNavigate();
  const [, setUserRole] = useState<string>("");
  const [hasProjects, setHasProjects] = useState(false);
  const [campaignStatusEnums, setCampaignStatusEnums] = useState<campaignStatusEnums[]>([]);
  const [selectedAccountNames, setSelectedAccountNames] = useState<string>("");
  const [isAccountPopupOpen, setIsAccountPopupOpen] = useState<boolean>(false);
  const [adminReviewCampaigns, setAdminReviewCampaigns] = useState<{ campaignId: string, campaignName: string, count: number }[]>([]);
  const [hasTemplates, setHasTemplates] = useState<boolean>(false);
  const [isCheckingTemplates, setIsCheckingTemplates] = useState<boolean>(false);
  const columns = [{ key: "campaignName", label: "Campaign Name", sortable: true, headerRender: (label: string) => (<div className="sortable-header" onClick={() => requestSort("campaignName")}> {label}<span className="sort-icon">{getSortIcon("campaignName")}</span> </div>) }, { key: "accountName", label: "Account Name" }, { key: "buildFormula", label: "Build Formula" }, { key: "campaignType", label: "Campaign Type" }, { key: "auditObjective", label: "Audit Objective" }, { key: "auditScope", label: "Audit Scope" }, { key: "auditTeam", label: "Audit Team" }, { key: "createdBy", label: "Created By" }, { key: "updatedBy", label: "Updated By" }, { key: "updatedDate", label: "Updated Date" }, { key: "campaignStartDate", label: "Campaign Start Date" }, { key: "campaignEndDate", label: "Campaign End Date" }, { key: "createdDate", label: "Campaign Created Date" }, { key: "frequency", label: "Frequency" }, { key: "campaignStatus", label: "Campaign Status" }];
  const { roleName } = EncryptionUtils.getAuthInfo();
  const clientId = localStorage.getItem("clientId");
  const [message, setMessage] = useState<ToastMessage | null>(null);
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["campaigns"]) {
      setFields(permissions.tabs["campaigns"].fields);
    } else {
      console.log("No permissions found for 'campaigns' tab");
    }
    setUserRole(roleName);
  }, [roleName]);
  useEffect(() => {
    const fetchStatusEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/CampaignStatusEnum");
        setCampaignStatusEnums(response);
      } catch (error) {
        console.error("Error fetching status enums:", error);
      }
    };
    fetchStatusEnums();
  }, []);
  useEffect(() => {
    const fetchAdminReviewCampaigns = async () => {
      try {
        const payload = buildUserPayload();
        const requestBody = [{ field: "itemStatus", operator: "=", value: "ADMIN_REVIEW" }, { field: "clientId", operator: "=", value: clientId }, ...(payload ? [payload] : [])];
        const response = await apiCall("post", `/api/campaign-projects/search?page=0&size=2147483647`, requestBody);
        const campaignMap = new Map<string, { campaignName: string, count: number }>();
        response.content.forEach((project: any) => {
          if (campaignMap.has(project.campaignId)) {
            campaignMap.get(project.campaignId)!.count += 1;
          } else {
            campaignMap.set(project.campaignId, { campaignName: project.campaignName, count: 1 });
          }
        });
        const campaigns = Array.from(campaignMap.entries()).map(([campaignId, data]) => ({ campaignId, campaignName: data.campaignName, count: data.count }));
        setAdminReviewCampaigns(campaigns);
      } catch (error) {
        console.error("Error fetching admin review campaigns:", error);
      }
    };
    fetchAdminReviewCampaigns();
  }, [clientId]);
  useEffect(() => {
    const checkTemplates = async () => {
      if (!clientId) return;
      setIsCheckingTemplates(true);
      try {
        const response = await apiCall("get", `/api/local-templates?clientId=${clientId}&page=0&size=10&status=ACTIVE`);
        const templates = response?.content || [];
        setHasTemplates(templates.length > 0);
      } catch (error) {
        setHasTemplates(false);
      } finally {
        setIsCheckingTemplates(false);
      }
    };
    checkTemplates();
  }, [clientId]);
  const handleNotificationClick = (campaignId: string, event: React.MouseEvent) => {
    event.stopPropagation();
    const campaign = adminReviewCampaigns.find(c => c.campaignId === campaignId);
    if (campaign) {
      navigate(`/adminreview/${campaign.campaignName}`, { state: { campaignId: campaign.campaignId } });
    }
  };
  const getCampaignStatusDescription = (statusValue: string) => {
    const foundStatus = campaignStatusEnums.find(enumItem => enumItem.value === statusValue);
    return foundStatus ? foundStatus.description : statusValue;
  };
  const formatDate = (dateString: string | undefined | null): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const getSortIcon = (key: string) => {
    if (!sortConfig || sortConfig.key !== key) { return <FaSort />; }
    return sortConfig.direction === 'ascending' ? <FaSortUp /> : <FaSortDown />;
  };
  const requestSort = (key: string) => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  const sortedData = React.useMemo(() => {
    if (!sortConfig) return data;
    return [...data].sort((a, b) => {
      if (sortConfig.key === 'projectId') {
        const aValue = parseInt(a.projectId);
        const bValue = parseInt(b.projectId);
        if (aValue < bValue) { return sortConfig.direction === 'ascending' ? -1 : 1 }
        if (aValue > bValue) { return sortConfig.direction === 'ascending' ? 1 : -1; }
        return 0;
      }
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }, [data, sortConfig]);
  const formatBuildFormula = (formula: Campaign['buildFormula']): string => {
    if (!formula || formula.length === 0) return "No formula applied";
    return formula.map(f => `${f.field} ${f.operator} ${f.value}`).join(" AND ");
  };
  const formatAccountNames = (accounts: string[] | undefined | null): string => {
    if (!accounts || accounts.length === 0) return "No account selected";
    return accounts.join(", ");
  };
  const handleAccountNameClick = (accounts: string[] | null) => {
    if (!accounts || accounts.length === 0) return;
    setSelectedAccountNames(formatAccountNames(accounts));
    setIsAccountPopupOpen(true);
  };
  const fetchAllCampaigns = async (): Promise<Campaign[]> => {
    try {
      const response = await apiCall("get", `/api/campaigns/all?page=0&size=${totalElements}&clientId=${clientId}`);
      return (response.content || []).map((item: Campaign) => ({ ...item, buildFormula: formatBuildFormula(item.buildFormula || []), campaignStatus: getCampaignStatusDescription(item.campaignStatus) }));
    } catch (error) {
      console.error("Failed to export campaigns. Please try again later.");
      return [];
    }
  };
  useEffect(() => {
    const fetchCampaigns = async () => {
      setLoading(true);
      try {
        const response = await apiCall("get", `/api/campaigns/all?page=${currentPage - 1}&size=${itemsPerPage}&clientId=${clientId}`);
        setData(response?.content || []);
        setTotalPages(response?.totalPages || 0);
        setTotalElements(response?.totalElements || 0);
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCampaigns();
  }, [clientId, currentPage, itemsPerPage]);
  const handleCampaignIdClick = (campaignId: string, campaignName: string, campaignStatus: string, isHistoryAvailable: string, qcBufferDate: string) => {
    EncryptionUtils.set("campaignName", campaignName);
    localStorage.setItem("isHistoryAvailable", isHistoryAvailable);
    localStorage.setItem("qcBufferDate", qcBufferDate);
    const campaign = data.find(c => c.campaignId === campaignId);
    navigate(`/campaigndetails/${campaignId}`, { state: { campaignName, campaignStatus, campaignStartDate: campaign?.campaignStartDate } });
  };
  const handleCreateCampaign = () => { setIsConfirmPopupOpen(true) };
  const handleConfirmCreate = async (updateFormula: boolean) => {
    setIsConfirmPopupOpen(false);
    if (updateFormula && clientId) {
      try {
        await apiCall("patch", "/api/client-mappings/default-filters", { isDisabled: false, clientId });
      } catch (error) {
        console.error("Error updating default filters:", error);
      }
    }
    navigate("/createcampaign");
  };
  const handleEditClick = (campaign: Campaign) => { setSelectedCampaign(campaign); setIsPopupOpen(true) };
  const handleFormulaClick = (formula: any[] | null) => {
    if (!formula || formula.length === 0) return;
    setSelectedFormula(formatBuildFormula(formula));
    setIsFormulaPopupOpen(true);
  };
  const handleClosePopup = () => { setIsPopupOpen(false); setSelectedCampaign(null) };
  const handleCreateButtonClick = async () => {
    if (!hasTemplates) {
      setMessage(createToastMessage("Please create a checklist before creating a campaign", "warning", 3000));
      return;
    }
    try {
      const response = await apiCall("get", `/api/client-mappings/default-filters?clientId=${clientId}`);
      const filters = response?.filters;
      if (
        !filters || (Array.isArray(filters) && filters.length === 0)
      ) {
        setMessage(createToastMessage("Please add a filter on the Build Formula page before creating a campaign.", "warning", 3000));
        return;
      }
      handleCreateCampaign();
    } catch (error) {
      console.error("Error fetching default filters:", error);
      setMessage(createToastMessage("Failed to validate Build Formula filters", "error", 3000));
    }
  };
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        let requestBody: { field: string; operator: string; value: string }[] = [
          { field: "clientId", operator: "=", value: clientId ?? "" },
        ];
        if (roleName !== "Admin") {
          const payload = buildUserPayload();
          if (payload) {
            requestBody.push(payload);
          }
        }
        const response = await apiCall("post", `/api/projects/search?page=${currentPage - 1}&size=${itemsPerPage}`, requestBody);
        setHasProjects(response.content && response.content.length > 0);
      } catch (error) {
        console.error("Error fetching data:", error);
        setHasProjects(false);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, [clientId, currentPage, itemsPerPage, roleName]);
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Campaigns</h2>
        <div className="table-title-actions">
          {fields.create && hasProjects && (
            <button className="campaign-create" onClick={handleCreateButtonClick} disabled={isCheckingTemplates}>Create Campaign</button>
          )}
          <ExportButton data={data.map(item => ({ ...item, buildFormula: formatBuildFormula(item.buildFormula), campaignStatus: getCampaignStatusDescription(item.campaignStatus) }))} columns={columns} fetchAllData={fetchAllCampaigns} fileName="campaigns" />
        </div>
      </div>
      <div>
        <div className="table-container">
          <div className="table-inner-container">
            <table className="main-table">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th key={column.key}>{column.headerRender ? column.headerRender(column.label) : column.label}</th>
                  ))}
                  {fields.edit && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((campaign) => {
                    const needsReview = adminReviewCampaigns.some(c => c.campaignId === campaign.campaignId);
                    return (
                      <tr key={campaign.campaignId}>
                        <td onClick={() => fields.view && handleCampaignIdClick(campaign.campaignId, campaign.campaignName, campaign.campaignStatus, campaign.isHistoryAvailable, campaign.qcBufferDate)} className={fields.view ? "clickable" : ""}>
                          <div className="campaign-name-container">
                            {campaign.campaignName}
                            {roleName && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) && needsReview && (
                              <FaBell size={16} className="campaign-notification-icon" onClick={(e) => handleNotificationClick(campaign.campaignId, e)} title="Items need review" />
                            )}
                          </div>
                        </td>
                        <td className={campaign.accountName && campaign.accountName.length > 0 ? "clickable" : ""} onClick={() => campaign.accountName && campaign.accountName.length > 0 && handleAccountNameClick(campaign.accountName)}>
                          {campaign.accountName && campaign.accountName.length > 0 ? (
                            <span className="click-here-text">Click here</span>) : ("No accounts"
                          )}
                        </td>
                        <td className={campaign.buildFormula && campaign.buildFormula.length > 0 ? "clickable" : ""} onClick={() => campaign.buildFormula && campaign.buildFormula.length > 0 && handleFormulaClick(campaign.buildFormula)}>
                          {campaign.buildFormula && campaign.buildFormula.length > 0 ? <span className="click-here-text">Click here</span> : "No formula applied"}
                        </td>
                        <td>{campaign.campaignType || "N/A"}</td>
                        <td>{campaign.auditObjective || "N/A"}</td>
                        <td>{campaign.auditScope || "N/A"}</td>
                        <td>{campaign.auditTeam || "N/A"}</td>
                        <td>{campaign.createdBy || "N/A"}</td>
                        <td>{campaign.updatedBy || "N/A"}</td>
                        <td>{formatDate(campaign.updatedDate) || "N/A"}</td>
                        <td>{formatDate(campaign.campaignStartDate) || "N/A"}</td>
                        <td>{formatDate(campaign.campaignEndDate) || "N/A"}</td>
                        <td>{formatDate(campaign.createdDate) || "N/A"}</td>
                        <td>{campaign.frequency || "N/A"} days</td>
                        <td>{getCampaignStatusDescription(campaign.campaignStatus) || "N/A"}</td>
                        {fields.edit && (
                          <td>{campaign.campaignStatus === "NOT_STARTED" ? (<FaEdit className="action-button" onClick={() => handleEditClick(campaign)} />) : ("N/A")}</td>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={columns.length + (fields.edit ? 1 : 0)} className="no-data">No campaigns found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
      {isPopupOpen && selectedCampaign && (
        <EditCampaignPopup campaign={selectedCampaign} onClose={handleClosePopup} />
      )}
      {isFormulaPopupOpen && (
        <FormulaPopup formula={selectedFormula} onClose={() => setIsFormulaPopupOpen(false)} />
      )}
      {isConfirmPopupOpen && (
        <BuildFormulaConfirmPopup onConfirm={handleConfirmCreate} onClose={() => setIsConfirmPopupOpen(false)} />
      )}
      {isAccountPopupOpen && (
        <AccountNamePopup formula={selectedAccountNames} onClose={() => setIsAccountPopupOpen(false)} />
      )}
    </div>
  );
};
export default CampaignDetails;